/**
* Created By: Jennifer Mancilla
* Creation Date: 08/09/2022
* PBI: 78280 - Estructura Cotizador Arrendamiento Bepensa
*
* Last Modifier:
* Last Modification:
*
* Feat: 
*
* version: 1.0.0
* copyright: 2022 INDUSTRIAS RESSER S.A DE C.V
*/

import { configureStore } from '@reduxjs/toolkit';
import { inProduction } from '../utils/constants';
import { dimensionsSlice } from './slices/dimensions';
import { DataCotizador} from './slices/DataCotizador';
import { ValidatesSlice } from './slices/Validates';
import { DataResponseSlice} from './slices/DataResponse';

export const store = configureStore({
    reducer: {
        dimensions: dimensionsSlice.reducer,
        DataCotizador: DataCotizador.reducer,
        Validates: ValidatesSlice.reducer,
        DataResponse: DataResponseSlice.reducer
    },
    devTools: !inProduction,
});

// Infer the `RootState` and `AppDispatch` types from the store itself
export type RootState = ReturnType<typeof store.getState>;
// Inferred type: {posts: PostsState, comments: CommentsState, users: UsersState}
export type AppDispatch = typeof store.dispatch;